<ng-content />
@if (showDelete) {
  <button
    class="absolute! right-2 top-2 z-20 opacity-0 hover:opacity-100! group-hover:opacity-90"
    data-testid="delete-button"
    size="xs"
    tuiButtonX
    type="button"
    (click)="delete.emit()"></button>
}
@if (caption) {
  <div
    class="absolute -bottom-1 z-10 w-full bg-linear-to-t from-background-primary-solid via-background-primary-solid/60 via-60% p-2 pt-8 opacity-0 transition-all group-hover:bottom-0 group-hover:opacity-100">
    <p class="line-clamp-2 break-all text-xs text-background-primary-alt">{{ caption }}</p>
  </div>
}
